import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source']
  static values = { attribute: String, name: String }

  connect () {
    this.element.addEventListener('submit', this.inject, true)
  }

  disconnect () {
    this.element.removeEventListener('submit', this.inject, true)
  }

  inject = (event) => {
    const form = event.target
    if (!(form instanceof window.HTMLFormElement)) return

    this.sourceTargets.forEach((source) => {
      if (!source.hasAttribute(this.attributeValue)) return

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = this.nameValue
      input.value = source.dataset.payload ?? source.getAttribute(this.attributeValue)
      form.appendChild(input)
      window.requestAnimationFrame(() => input.remove())
    })
  }
}
